<script setup lang="ts">
  import { IResultItems, useMMStore } from '@/store/MarvelMachine'
  import { ref, watchEffect } from 'vue'
  const mmStore = useMMStore()
  const $resultItem = ref()
  const props = defineProps({
    item: {
      type: Object,
      required: true,
    },
    doubledItem: {
      type: Object as PropType<IResultItems | null>,
      required: false,
    },
  })
  watchEffect(() => {
    if (props.doubledItem) {
      console.log('props.doubledItem :', props.doubledItem)
      setTimeout(() => {
        $resultItem?.value?.classList.add('show-double-animation')
      }, 10)
      setTimeout(() => {
        $resultItem?.value?.classList.remove('show-double-animation')
      }, 5000)
    }
  })
</script>

<template>
  <div
    ref="$resultItem"
    class="marvel-machine-result-item"
    :class="{
      doubled: props.doubledItem,
      doubleRunning: mmStore.game.isDoubleRunning,
      gameResetting: mmStore.game.isGameBeingResetted,
    }"
  >
    <div
      class="marvel-machine-result-item__item-image"
      :style="{
        backgroundImage: `url('https://nxcache.nexon.net/maplestory/shop/gachapon/img/items/${props.item.itemImageName}.png')`,
      }"
    ></div>
    <div class="marvel-machine-result-item__item-name">{{ props.item.itemName }}</div>
    <div class="marvel-machine-result-item__item-code">
      Code: {{ props.item.couponCode }}
      <div v-if="props.doubledItem">Code: {{ props.doubledItem.couponCode }}</div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
  .marvel-machine-result-item {
    flex: 33%;
    height: calc(350px * var(--marvel-desktopRatio));
    background: url('@/assets/imgs/mavelmachine/marvelResultItem/item-box.png') no-repeat center center / 100% auto;
    position: relative;
    text-align: center;
    color: var(--marvel-accent);
    font-weight: bold;
    transition: all 0.3s;
    &:after {
      content: '';
      width: calc(78px * var(--marvel-desktopRatio));
      height: calc(72px * var(--marvel-desktopRatio));
      top: calc(40px * var(--marvel-desktopRatio));
      left: 0;
      position: absolute;
      background: url('@/assets/imgs/mavelmachine/marvelResultItem/doubled-tag.png') no-repeat center center / 100% auto;
      opacity: 0;
      transition: opacity 0.3s;
    }
    &:before {
      content: '';
      width: 100%;
      height: 100%;
      left: 0;
      top: 0;
      position: absolute;
      background: url('@/assets/imgs/mavelmachine/marvelResultItem/doubled-animation.png') no-repeat center center /
        100% auto;
      opacity: 0;
      transition: opacity 0.3s;
      z-index: 3;
    }
    &.gameResetting {
      opacity: 0;
      transform: scale(1.1);
    }
    @keyframes result-item-doubled {
      0% {
        transform: rotate(0deg);
      }
      25% {
        transform: rotate(4deg);
      }
      50% {
        transform: rotate(0eg);
      }
      75% {
        transform: rotate(-4deg);
      }
      100% {
        transform: rotate(0deg);
      }
    }

    @keyframes result-item-running-double {
      0% {
        transform: translateX(0);
      }
      25% {
        transform: translateX(3px);
      }
      50% {
        transform: translateX(-3px);
      }
      75% {
        transform: translateX(3px);
      }
      100% {
        transform: translateX(0);
      }
    }
    &.doubled {
      background: url('@/assets/imgs/mavelmachine/marvelResultItem/item-box-doubled.png') no-repeat center center / 100%
        auto;
      animation: result-item-doubled 0.2s 5;
      &:after {
        opacity: 1;
      }

      .marvel-machine-result-item__item-code {
        bottom: calc(27px * var(--marvel-desktopRatio));
      }
    }

    &.show-double-animation {
      &:before {
        opacity: 1;
        z-index: 3;
      }
    }
    &.doubleRunning {
      animation: result-item-running-double 0.3s infinite;
    }
  }

  .marvel-machine-result-item__item-image {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    top: calc(65px * var(--marvel-desktopRatio));
    width: calc(120px * var(--marvel-desktopRatio));
    height: calc(120px * var(--marvel-desktopRatio));
    background: no-repeat center center / 100% 100%;
  }
  .marvel-machine-result-item__item-name {
    position: absolute;
    bottom: calc(88px * var(--marvel-desktopRatio));
    left: 50%;
    color: white;
    transform: translateX(-50%);
    width: 87%;
    overflow: hidden; /* make sure it hides the content that overflows */
    white-space: nowrap; /* don't break the line */
    text-overflow: ellipsis;
    font-size: calc(15.2px * var(--marvel-desktopRatio));
    font-family: 'maplestory-bold';
  }

  .marvel-machine-result-item__item-code {
    position: absolute;
    bottom: calc(40px * var(--marvel-desktopRatio));

    width: 100%;
    font-size: calc(14px * var(--marvel-desktopRatio));
    font-weight: bold;
    z-index: 4;
  }

  @media #{$tabletForMarvel} {
  }

  @media #{$mobileForMarvel} {
    .marvel-machine-result-item {
      background-image: url('@/assets/imgs/mavelmachine/marvelResultItem/item-box-mobile.png');
      height: 41.5vw;
      flex: 33.3%;
      &.doubled {
        background-image: url('@/assets/imgs/mavelmachine/marvelResultItem/item-box-doubled-mobile.png');
      }
      &:after {
        width: 10vw;
        height: 10vw;
        top: 0.7vw;
      }
    }
    .marvel-machine-result-item__item-image {
      width: 14vw;
      height: 14vw;
      top: 7vw;
    }
    .marvel-machine-result-item__item-code {
      display: none;
    }
    .marvel-machine-result-item__item-name {
      font-size: 2.3vw;
      bottom: 5.9vw;
    }
  }
</style>
